// Live regions must already exist in the DOM before content is inserted, or screen readers won't announce it.
const createLiveRegion = () => {
    const region = document.createElement('div');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    Object.assign(region.style, {
        position: 'absolute', width: '1px', height: '1px', margin: '-1px', padding: '0',
        overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap', border: '0'
    });
    document.body.appendChild(region);
    return region;
};

// React-managed portal target; kept separate so announce() never clobbers portal children.
export const popupLiveRegion = createLiveRegion();

const messageLiveRegion = createLiveRegion();
let announceTimer;

export const announce = (text) => {
    clearTimeout(announceTimer);
    // Clear first so repeating the same text is still announced.
    messageLiveRegion.textContent = '';
    announceTimer = setTimeout(() => { messageLiveRegion.textContent = text; }, 100);
};
